
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","d":"M21.5 2.5v5h-3v-5z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M13 2v20h-2V2z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M16 4v2H8V4zM16 18v2H8v-2z"}}),_c('path',{attrs:{"stroke":"currentColor","d":"M5.5 2.5v5h-3v-5z"}}),_c('path',{attrs:{"fill":"currentColor","stroke":"currentColor","d":"M21.5 16.5v5h-3v-5zM5.5 16.5v5h-3v-5z"}}),_c('ellipse',{attrs:{"cx":"12","cy":"5","rx":"2","ry":"3","transform":"rotate(90 12 5)","fill":"currentColor"}}),_c('ellipse',{attrs:{"cx":"12","cy":"19","rx":"2","ry":"3","transform":"rotate(90 12 19)","fill":"currentColor"}})])
          )
        }
      }
    